import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import speciesGroupReducer from '../features/speciesGroup/speciesGroupSlice';
import dropdownReducer from '../features/dropdown/dropdownSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['speciesGroup', 'dropdown'], // Persist both species groups and dropdown data

};

const rootReducer = combineReducers({
  speciesGroup: speciesGroupReducer,
  dropdown: dropdownReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);



export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
